import { DomainRegistrarFormValidationSchema } from '../../../domainRegistrars.interfaces';

export const domainRegistrarsFormValidationSchema: DomainRegistrarFormValidationSchema = {
  name: [
    { required: true, message: 'Введіть назву реєстратора домену' },
    { type: 'string', message: 'Реєстратор домену має бути строкою' },
    { min: 1, max: 255, message: 'Реєстратор домену має бути довжиною не менше 1 символа та не більше 255' }
  ],
  link: [
    { required: true, message: 'Введіть посилання на реєстратор домену' },
    { type: 'url', message: 'Посилання має бути URl адресою' },
    { min: 1, max: 255, message: 'Посилання має бути довжиною не менше 1 символа та не більше 255' }
  ]
};
